export default "__VITE_ASSET__BNvDPERM__"